<ng-container *transloco="let translate">
	@if (
		{
			collapsed: sidenavService.collapsed$ | async,
			user: user$ | async,
			nextTheme: nextTheme$ | async,
			currentTheme: currentTheme$ | async,
		};
		as vm
	) {
		@if (!vm.collapsed && vm.user?._raw.plan === UserStatus.TRIAL && !isNativePlatform) {
			<div class="p-1 mx-1 rounded-2 gap-0.5 bg-imp-8/20 flex flex-col items-start">
				<div class="py-0.5 pr-2 pl-1 gap-1 bg-fg-800 flex items-center rounded-circle">
					<span class="w-2 h-2">✨</span>
					<span class="text-sp-1.5 leading-none fc-inverse">
						{{ translate('home.account_deletion_warning.title') }}
					</span>
				</div>
				<div class="p-1 gap-1 w-full flex flex-col items-start">
					<span class="text-sp-2.25">
						{{
							translate('home.account_deletion_warning.trial_ending', {
								days: $daysUntilTrialExpires(),
							})
						}}
					</span>
					<progress-line
						class="w-full h-0.5 [display:var(--display-progress)]"
						[value]="($daysSinceTrialStarted() / $trialTotalDays()) * 100"
					></progress-line>
					<span class="text-sp-1.5 fc-800 opacity-60">
						{{
							translate('home.account_deletion_warning.time_period', {
								days:
									$daysSinceTrialStarted() > $trialTotalDays()
										? $trialTotalDays()
										: $daysSinceTrialStarted(),
								finishDate: $trialTotalDays(),
							})
						}}
					</span>
				</div>
				<a
					href="https://myreach.io/pricing"
					target="_blank"
					class="pr-0.5 pl-1 gap-1 w-full flex items-center"
				>
					<span class="flex-auto text-sp-1.75 fc-800">
						{{ translate('home.account_deletion_warning.plans') }}
					</span>
					<i class="icon-arrow arrow-right flex-none text-sp-2.75"></i>
				</a>
			</div>
		}

		<button
			#anchor
			class="profile-menu-button py-1 pl-0.5 pr-0.5 rounded-1 w-full flex flex-row items-center justify-start hover:bg-standard-hover"
			[class.hover:bg-standard-hover]="!vm.collapsed"
			(click)="vm.collapsed ? navigateToProfileSettings() : menu?.open(anchor)"
		>
			<div class="gap-1.25 flex flex-row items-center min-w-0">
				<a
					[routerLink]="['/', 'home', 'profile']"
					[tooltip]="translate('general.profile')"
					(click)="$event.preventDefault(); $event.stopPropagation()"
					class="profile-link cursor-pointer"
				>
					<reach-user-thumbnail
						class="user-thumbnail"
						[user]="$any(vm.user)"
					></reach-user-thumbnail>
				</a>
				@if (!vm.collapsed) {
					<div class="flex-none flex flex-col">
						<span class="text-body1">{{ vm.user?.fullName }}</span>
						<span class="text-small2 fc-400">{{ vm.user?.email }}</span>
					</div>
				}
				<!-- Uncomment when plans done -->
				<!-- <div
					*ngIf="!vm.collapsed"
					class="ml-1 rounded-1 plan py-0.5 fc-400 text-xs"
					style="padding-left: 6px; padding-right: 6px;"
					>
					Free Plan
				</div> -->
			</div>
			@if (!vm.collapsed) {
				<div class="ml-auto flex flex-row items-center">
					<!-- Uncomment when notifications are done -->
					<!-- <a uiNewButtonIcon>
						<i class="icon-notifications"></i>
					</a> -->
					<i
						class="icon-chevron fc-400"
						[class.chevron-down]="$menuStatus()"
						[class.chevron-up]="!$menuStatus()"
					></i>
				</div>
			}
		</button>

		<ng-template integrationPrimaryBtn #errorTpl>
			{{ 'general.errors.unknown' | transloco }}
		</ng-template>

		<reach-menu
			#menu
			[activeSection]="'1'"
			(opened)="toggleMenuSettings()"
			(closed)="toggleMenuSettings()"
		>
			<ng-container
				*reachMenuSection="
					'1';
					desktopType: MenuDesktopType.FLOATING;
					anchor: anchor;
					widthSize: WidthSize.PX240;
					lightBg: true;
					showFooter: true;
					bordered: true;
					forcePosition: 'TOP'
				"
			>
				<div class="flex-auto gap-0.5 w-full flex flex-col items-start">
					<a
						class="py-0.75 px-1 rounded-0.75 text-body1 gap-1 w-full fc-800 flex items-center hover:bg-standard-hover transition-background duration-200 ease-in-out"
						href="https://handbook.rea.ch/"
						(click)="menu?.close()"
						target="_blank"
					>
						<i class="text-sp-2 fc-400 icon-handbook"></i>
						<span class="flex-auto">Handbook</span>
						<i class="icon-arrow-diagonal text-sp-2 fc-400"></i>
					</a>

					@if (showBrowserExtension) {
						<button
							class="py-0.75 px-1 rounded-0.75 text-body1 gap-1 w-full fc-800 flex items-center hover:bg-standard-hover transition-background duration-200 ease-in-out"
							(click)="openExtensionPage(); menu?.close()"
						>
							<i class="text-sp-2 fc-400 icon-puzzle-outline"></i>
							<span class="flex-auto">Browser extension</span>
							<i class="icon-arrow-diagonal text-sp-2 fc-400"></i>
						</button>
					}

					<div class="separator"></div>

					<div
						class="py-0.25 pr-0.5 pl-1 text-m gap-0.25 w-full fc-800 flex relative items-center"
					>
						<div class="flex-auto text-body1 gap-1 flex items-center">
							<i class="text-sp-2 fc-400 icon-palette"></i>
							Theme
						</div>
						<div class="right-0 rounded-1.25 flex-none bg-270 theme-switcher">
							<span
								class="theme-switcher-pill border border-line-230 rounded-1 bg-180 border-[0.5px]!"
								[style.transform]="getThemePillTransform()"
							></span>
							@for (theme of allThemes; track $index) {
								<button
									class="theme-switcher-option group/sidenav-footer py-0.5 px-1 rounded-1.25 flex-none hover:bg-standard-hover"
									[class.hover:bg-standard-hover]="
										theme !== vm.currentTheme?.theme
									"
									[tooltip]="themeMap[theme].tooltipKey | transloco"
									(click)="setTheme(theme)"
								>
									<i
										class="text-sp-2 group-hover/sidenav-footer:fc-800"
										[class.fc-500]="theme !== vm.currentTheme?.theme"
										[class]="themeMap[theme].icon"
									></i>
								</button>
							}
						</div>
					</div>

					<button
						class="py-0.75 px-1 rounded-0.75 text-body1 gap-1 w-full fc-800 flex items-center hover:bg-standard-hover transition-background duration-200 ease-in-out"
						(click)="navigateToProfileSettings(); menu?.close()"
					>
						<i class="text-sp-2 fc-400 icon-settings"></i>
						Settings
					</button>

					<div class="separator"></div>

					<button
						class="py-0.75 px-1 rounded-0.75 text-body1 gap-1 w-full fc-800 flex items-center hover:bg-warn-500/10 hover:text-warn group/sidenav-footer [transition:background-color_0.2s_ease-in-out,_color_0.2s_ease-in-out]"
						(click)="signOut(); menu?.close()"
					>
						<i
							class="text-sp-2 fc-400 group-hover/sidenav-footer:text-warn icon-log-out"
						></i>
						Sign out
					</button>
				</div>
			</ng-container>
		</reach-menu>
	}
</ng-container>
